import {
  ConfirmedCreditCard,
  ConfirmedCreditCardShape
} from './../../domain/creditCard';
import {
  UnauthenticatedError,
  UnknownNetworkError
} from './../../application/commonModels/apiResponse';
import { STATUS_CODE } from './httpModel';
import { SecureUserProfile, UserData, UserProfile } from './models';
import ApiClient from './client';
import User from '../../domain/user';
import { Option } from '../../utils/option';
import { UnauthorizedError } from '../../application/commonModels/apiResponse';
import { AxiosResponse } from 'axios';

export const getUserProfile = async () =>
  (await ApiClient.instance.get<UserData>('/user', 'wapi'))
    .map(({ data }) => data)
    .map(({ user }) => ({
      user: new User(
        user.id,
        user.language,
        user.secure_user.email,
        user.secure_user.access_token,
        user.secure_user.refresh_token,
        user.secure_user.authorized_at,
        user.secure_user.confirmed_at,
        user.created_at,
        user.secure_user_profile
      ),
      cards: Option(user.secure_gmo_credit_cards)
        .map((cards) =>
          cards.map(
            (c) =>
              new ConfirmedCreditCard(
                c.id,
                c.holder_name,
                c.exp_month,
                c.exp_year,
                c.lower_four_digits,
                c.brand,
                c.primary
              )
          )
        )
        .getOrElse<ConfirmedCreditCardShape[]>(() => [])
    }))
    .leftMap((e) =>
      Option<AxiosResponse>(e.response).match({
        Some: ({ status }) => {
          switch (status) {
            case STATUS_CODE.UNAUTHENTICATED:
              return new UnauthorizedError();
            case STATUS_CODE.UNAUTHENTICATED:
              return new UnauthenticatedError();
            default:
              return new UnknownNetworkError();
          }
        },
        None: () => new UnknownNetworkError()
      })
    );

export const updateUserProfile = async (userProfile: SecureUserProfile) =>
  (
    await ApiClient.instance.post<UserProfile>(
      '/secure_user_profiles',
      { secure_user_profile: userProfile },
      'wapi'
    )
  )
    .map(({ data }) => data)
    .leftMap((e) =>
      Option<AxiosResponse>(e.response).match({
        Some: ({ status }) => {
          switch (status) {
            case STATUS_CODE.UNAUTHENTICATED:
              return new UnauthorizedError();
            default:
              return new UnknownNetworkError();
          }
        },
        None: () => new UnknownNetworkError()
      })
    );

export default {
  getUserProfile,
  updateUserProfile
};
